<!-- <div class="datagridsidebar__header bg"> -->
<!-- <h2>Export</h2> -->
<!-- <div class="sidebar__action"> -->
<!-- <span class="advanced-filter">Reset to Default</span> -->
<!-- <a class="close" (click)="onClose($event)"><i class="fa-regular fa-times"></i></a> -->
<!-- </div> -->
<!-- </div> -->
<!-- <br /> -->
<div class="content">
  <div class="datagrid-form">
    <div class="datagrid__fields">
      <div class="form-group"><label for="title-input">Export Limit</label>
        <div class="action__item dropdown--container" [style]="{ width: '100%' }">
          <div class="dropdown-list action__item dropdown--container" [style]="{ width: '100%' }">
            <f-dropdown [style]="{ minWidth: '100%' }" [(ngModel)]="exportOption" [options]="exportOptions"
              placeholder="Select a location" optionLabel="name" optionValue="value">
              <ng-template let-item pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ item.name }}</div>
                </div>
              </ng-template>
            </f-dropdown>
          </div>
        </div>
      </div>
    </div>


    <!-- <div class="datagrid__fields">
        <div class="form-group"><label for="title-input">Extract Type</label>
          <f-dropdown [style]="{ minWidth: '100%' }" [(ngModel)]="exportType" [options]="exportTypes"
            placeholder="Select a location" optionLabel="name" optionValue="value">
            <ng-template let-item pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ item.name }}</div>
              </div>
            </ng-template>
          </f-dropdown>
        </div>
      </div> -->


    <div class="datagrid__fields">
      <div class="form-group"><label for="title-input">Destination</label>
        <f-dropdown [disabled]="true" [style]="{ minWidth: '100%' }" [(ngModel)]="location" [options]="locations"
          placeholder="Select a location" optionLabel="name" optionValue="value">
          <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ item.name }}</div>
            </div>
          </ng-template>
        </f-dropdown>
      </div>
    </div>

    @if (location === 'end') {
    <div class="datagrid__fields">
      <label for="name" class="d-block">Email Addresses</label>
      <p-chips [style]="{ width: '100%' }" placeholder="abx@gmail.com" [(ngModel)]="emailAddresses"></p-chips>
    </div>
    }

    <div class="datagrid__fields">
      <label for="name" class="">Type</label>
      <f-dropdown [disabled]="true" [style]="{ minWidth: '100%' }" [(ngModel)]="fileType" [options]="fileTypes"
        placeholder="Select a type" optionLabel="name" optionValue="value">
        <ng-template let-item pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>{{ item.name }}</div>
          </div>
        </ng-template>
      </f-dropdown>
    </div>

  </div>
  <!-- <p>
      In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual
      form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a
      placeholder before final copy.
    </p> -->
</div>
<br />
<button (click)="onExport($event)" type="button" class="btn-bg btn-primary">Export</button>